<template>
  <ui-dropper v-if="modelBlog?.is_editing" chevron-left>
    <template #head>
      <div class="space-x-4 w-full flex items-baseline">
        <b>Blog</b>
        <span>Files</span>

        <div class="flex-grow flex justify-end">
          <blog-button
            text="Add file"
            class="dark !text-sm !py-1"
            @click.capture.prevent.stop="refFileModal?.open()"
            />
        </div>

        <ui-file-modal
          ref="refFileModal"
          @file="methodAttachFileToBlog(modelBlog.id,$event.id).then((status) => {notify(status)})"
          />
      </div>
    </template>
    <div class="shadow-inner shadow-gray-400 p-4 rounded">
      <blog-files v-model="modelBlog" />
    </div>
  </ui-dropper>
</template>

<script setup lang="ts">
const refFileModal = ref<any>()
const modelBlog = defineModel<Blog>()
</script>
